import { render, staticRenderFns } from "./DispatchOverview.vue?vue&type=template&id=9a57f332&scoped=true"
import script from "./DispatchOverview.vue?vue&type=script&lang=js"
export * from "./DispatchOverview.vue?vue&type=script&lang=js"
import style0 from "./DispatchOverview.vue?vue&type=style&index=0&id=9a57f332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a57f332",
  null
  
)

/* custom blocks */
import block0 from "./DispatchOverview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports